var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 52 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AFAFAF",
    fillRule: "evenodd",
    d: "M51.579 11.127c0-3.668-1.777-6.563-5.172-6.563-3.41 0-5.473 2.895-5.473 6.534 0 4.312 2.435 6.49 5.931 6.49 1.705 0 2.995-.387 3.969-.931V13.79c-.974.487-2.092.788-3.51.788-1.39 0-2.622-.487-2.78-2.177h7.006c0-.187.029-.932.029-1.275zm-7.078-1.362c0-1.619.989-2.292 1.891-2.292.874 0 1.806.673 1.806 2.292H44.5zM35.404 4.564c-1.404 0-2.306.66-2.808 1.118l-.186-.888h-3.152V21.5l3.582-.76.014-4.054c.516.372 1.275.902 2.536.902 2.565 0 4.9-2.063 4.9-6.605-.014-4.155-2.378-6.419-4.886-6.419zm-.86 9.872c-.845 0-1.346-.3-1.69-.673l-.014-5.316c.372-.415.888-.702 1.705-.702 1.303 0 2.206 1.462 2.206 3.339 0 1.92-.888 3.352-2.206 3.352zM24.328 3.72l3.596-.774V.037l-3.596.76v2.922z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AFAFAF",
    d: "M27.924 4.809h-3.596v12.536h3.596V4.81z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#AFAFAF",
    fillRule: "evenodd",
    d: "M20.472 5.868l-.229-1.06h-3.095v12.537h3.582V8.849c.846-1.104 2.278-.903 2.723-.745V4.808c-.459-.172-2.135-.487-2.98 1.06zM13.311 1.699l-3.496.745-.014 11.476c0 2.12 1.59 3.682 3.71 3.682 1.176 0 2.035-.215 2.508-.473v-2.908c-.458.186-2.722.845-2.722-1.275V7.86h2.722V4.808h-2.722l.014-3.11zM3.625 8.447c0-.559.458-.773 1.218-.773 1.089 0 2.464.33 3.553.917V5.224c-1.19-.473-2.364-.66-3.553-.66C1.934 4.564 0 6.084 0 8.62c0 3.955 5.444 3.324 5.444 5.03 0 .658-.573.873-1.375.873-1.19 0-2.708-.487-3.911-1.146v3.41a9.932 9.932 0 003.911.816c2.98 0 5.029-1.475 5.029-4.04-.014-4.27-5.473-3.51-5.473-5.115z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogo);
export default __webpack_public_path__ + "static/media/stripe-logo.c641c3e9da4588a8c6dc6477961b6444.svg";
export { ForwardRef as ReactComponent };